import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../../../../app.config';
import { CompetitionApi } from '../api/competition.api';

@Injectable({
  providedIn: 'root'
})
export class CompetitionHttpService {

  constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) { }

  registerUserForCompetition(userId: string, competitionId: string, data: any) {
    const url = `${this.config.competitionUrl}/${competitionId}/user/${userId}`
    
    return this.http.post<CompetitionApi>(url, data);
  }
}
